import { RulerProps, RulerInterface } from "@scena/react-ruler/declaration/types";
import {
    PROPERTIES as RULER_PROPERTIES,
    METHODS as RULER_METHODS,
} from "@scena/react-ruler";

export const PROPERTIES: Array<keyof RulerProps> = RULER_PROPERTIES;
export const METHODS: Array<keyof RulerInterface> = RULER_METHODS;
